import React from 'react';
import { createPortal } from 'react-dom';

type SettingsNavContextType = {
    title?: HTMLElement;
    setPageWidth(width: string): void;
};
export const SettingsNavContext = React.createContext<SettingsNavContextType | null>(null);

function useSettingsNavContext() {
    const ctx = React.useContext(SettingsNavContext);
    if (!ctx) {
        throw new Error('Null SettingsNavContext context');
    }
    return ctx;
}

export function useSettingsPageWidth(width: string) {
    useSettingsNavContext().setPageWidth(width);
}

export function SettingsNavTitle(props: { children?: React.ReactNode }) {
    const context = useSettingsNavContext();
    if (!context.title) {
        return null;
    }

    return createPortal(props.children, context.title);
}
